import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, } from 'react';
import { ErrorBoundary, useErrorBoundary, getErrorMessage, } from 'react-error-boundary';
import DefaultErrorBoundary from './components/DefaultErrorBoundary';
export { useErrorBoundary, getErrorMessage, };
export default function DErrorBoundary({ name, fallback, resetKeys, onReset, onError, children, }) {
    const handleError = useCallback((error, info) => {
        // eslint-disable-next-line no-console
        console.error(`[DErrorBoundary${name ? `:${name}` : ''}]`, getErrorMessage(error), info);
        onError === null || onError === void 0 ? void 0 : onError(error, info);
    }, [name, onError]);
    const FallbackRender = useCallback((props) => {
        if (fallback)
            return fallback(props);
        return (_jsx(DefaultErrorBoundary, { resetErrorBoundary: props.resetErrorBoundary }));
    }, [fallback]);
    return (_jsx(ErrorBoundary, { resetKeys: resetKeys, onReset: onReset, onError: handleError, fallbackRender: FallbackRender, children: children }));
}
//# sourceMappingURL=DErrorBoundary.js.map